import Switcher from "@components/switcher/Switcher";
import CPGLogsDetails from "./CPGLogsDetails";
import CPGOrderFlowDetails from "./CPGOrderFlowDetails";
import CPGTransactionDetailsCounterparty from "./CPGTransactionDetailsCounterparty";

interface CPGDetailsTabsProps {
  transactionId: number;
  merchantOrderId?: string;
}

const CPGDetailsTabs: React.FC<CPGDetailsTabsProps> = ({
  transactionId,
  merchantOrderId,
}) => {
  const tabs = [
    {
      label: "TRANSACTION",
      component: <CPGOrderFlowDetails transactionId={transactionId} />,
    },
    {
      label: "LOGS",
      component: <CPGLogsDetails transactionId={transactionId} />,
    },
    {
      label: "COUNTERPARTY",
      component: (
        <CPGTransactionDetailsCounterparty
          transactionId={transactionId}
          merchantOrderId={merchantOrderId}
        />
      ),
    },
  ];
  return (
    <div className="flex flex-col gap-[12px]">
      <Switcher tabs={tabs} />
    </div>
  );
};

export default CPGDetailsTabs;
